import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 添加管理员token
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    
    // 添加sessionId
    const sessionId = localStorage.getItem('sessionId');
    if (sessionId) {
      config.headers['X-Session-ID'] = sessionId;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      // 401: 未授权
      if (status === 401) {
        localStorage.removeItem('adminToken');
        window.location.href = '/XiaoXin/login';
      }
      
      // 返回错误信息
      throw new Error(data.message || '请求失败');
    } else if (error.request) {
      throw new Error('网络错误，请检查网络连接');
    } else {
      throw new Error(error.message || '未知错误');
    }
  }
);

// 授权码API
export const authAPI = {
  // 验证授权码
  verifyCode: (code) => apiClient.post('/verify-code', { code }),
};

// 测试API
export const testAPI = {
  // 提交测试答案
  submitAnswers: (data) => apiClient.post('/test/submit', data),
  
  // 获取报告
  getReport: () => apiClient.get('/test/report'),
};

// 管理员API
export const adminAPI = {
  // 登录
  login: (credentials) => apiClient.post('/XiaoXin/login', credentials),
  
  // 获取统计数据
  getStats: () => apiClient.get('/XiaoXin/stats'),
  
  // 获取授权码列表
  getAuthCodes: (params) => apiClient.get('/XiaoXin/authcodes', { params }),
  
  // 生成授权码
  createAuthCode: (data) => apiClient.post('/XiaoXin/authcodes', data),
  
  // 删除授权码
  deleteAuthCode: (id) => apiClient.delete(`/XiaoXin/authcodes/${id}`),
  
  // 获取测试结果列表
  getResults: (params) => apiClient.get('/XiaoXin/results', { params }),
  
  // 获取测试结果详情
  getResultDetail: (id) => apiClient.get(`/XiaoXin/results/${id}`),
};

export default apiClient;
